let cachedResult = null

const testSessionStorage = (): boolean => {
  if (cachedResult !== null) return cachedResult

  const mod = 'ignoreme'

  try {
    sessionStorage.setItem(mod, mod)
    sessionStorage.removeItem(mod)
    cachedResult = true
    return true
  } catch (e) {
    cachedResult = false
    return false
  }
}

export default testSessionStorage
